// Shared fee/NSF keyword classifier mirrored from backend statements.py.
// Used by the Transactions form to flag fee-like descriptions on the fly.

export const NSF_KEYWORDS = [
  "nsf", "insufficient funds", "returned item", "returned check",
  "returned deposit", "overdraft", "od fee", "non-sufficient",
];

export const FEE_KEYWORDS = [
  "service charge", "service fee", "monthly fee", "monthly maintenance",
  "maintenance fee", "wire fee", "wire transfer fee", "atm fee",
  "foreign transaction fee", "stop payment fee", "account analysis fee",
  "minimum balance fee", "bank fee", "card fee", "paper statement fee",
  "incoming wire", "outgoing wire fee",
];

export function classifyFeeKind(description) {
  const d = (description || "").toLowerCase();
  if (!d) return null;
  if (NSF_KEYWORDS.some((k) => d.includes(k))) return "nsf";
  if (FEE_KEYWORDS.some((k) => d.includes(k))) return "fee";
  return null;
}
